import { FC } from 'react';
import { gql } from '@apollo/client';
import { useFormContext } from 'react-hook-form';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Select } from '@/components/react-hook-form/Select';
import { useQuery } from '@/hooks/graphql/useQuery';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import type { Schema } from '../../schema';

const OFFICES = gql`
  query offices {
    client {
      id
      offices {
        id
        name
      }
    }
  }
`;

interface OfficesQueryResult {
  client: {
    id: string;
    offices: {
      id: string;
      name: string;
    }[];
  };
}

export const Office: FC = () => {
  const {
    formState: { errors }
  } = useFormContext<Schema>();

  const { data, loading } = useQuery<OfficesQueryResult>(OFFICES, { fetchPolicy: 'network-only' });
  const options = data
    ? [{ value: '', label: '' }, ...data.client.offices.map(office => ({ value: office.id, label: office.name }))]
    : [{ value: '', label: '' }];

  return (
    <Panel>
      <Headding>適用事業所</Headding>
      <Item>
        <Select name="officeId" options={options} disabled={loading} isLoading={loading} />
        {errors.officeId?.message && <ErrorMessage>{errors.officeId.message}</ErrorMessage>}
      </Item>
    </Panel>
  );
};
